/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from 'react'
import { DisponibilityCalendar } from '@/components/PetSitter/EmtCalendar/DisponibilityCalendar'
import { Box, CircularProgress } from '@mui/material'
import { EmtIcon, EmtTypography } from 'emt-components-v2'
import { formatDate } from '@/utils/formatDate'
// import { useIsResponsive } from '@/hooks'
import { CalendarData, CalendarEvent } from '@/data/PetSitter/Calendar'

interface Range {
  uuid?: string
  start: Date
  end: Date
  type: string
}

interface LoadingState {
  add: boolean
  remove: boolean
  fetch: boolean
  delete: Set<string>
}

interface CalendarComponentProps {
  calendar: Pick<CalendarData, 'mainEvent' | 'days' | 'presets'>
  ranges: Range[]
  onAddRange: (newRange: Range, slug: string) => void
  onDeleteRange: (rangeToDelete: Range) => void
  loading: LoadingState
  currentMonth: Date
  setCurrentMonth: (date: Date) => void
  onUpdateMainEvent: (updatedSchedule: Partial<CalendarEvent>) => Promise<void>
}

const CalendarComponent: React.FC<CalendarComponentProps> = ({
  calendar,
  ranges,
  onAddRange,
  onDeleteRange,
  loading,
  currentMonth,
  setCurrentMonth,
  onUpdateMainEvent,
}) => {
  // Determine the start and end of the current month
  const startOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1)
  const endOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0)
  // const [isMobile] = useIsResponsive()

  // Filter ranges that overlap with the current month
  const filteredRanges = ranges.filter((range) => range.start <= endOfMonth && range.end >= startOfMonth)

  const handleDeleteRange = (index: number) => {
    const rangeToDelete = filteredRanges[index]
    onDeleteRange(rangeToDelete)
  }

  const presets = calendar.presets
  const mainEvent = calendar.mainEvent
  const mainEventApiSlug = mainEvent?.slug

  // Initialize selectedPreset with mainEventApiSlug if it differs from preset slug
  const [selectedPreset, setSelectedPreset] = useState<string | undefined>(() => {
    const matchingPreset = presets.find((p) => p.slug === mainEvent?.slug)
    if (matchingPreset) {
      return matchingPreset.slug !== mainEventApiSlug ? mainEventApiSlug : matchingPreset.slug
    }
    return mainEventApiSlug || mainEvent?.slug
  })

  useEffect(() => {
    // Only update selectedPreset if the current selectedPreset doesn't match the new mainEventApiSlug
    if (mainEvent?.slug && mainEventApiSlug && selectedPreset !== mainEventApiSlug) {
      setSelectedPreset(mainEventApiSlug)
    }
  }, [mainEventApiSlug])

  // COMMENTED TO USE ONLY INDISPONIBILITY RANGES

  // const [localSchedule, setLocalSchedule] = useState({
  //   scheduleEveryMonday: mainEvent?.scheduleEveryMonday || false,
  //   scheduleEveryTuesday: mainEvent?.scheduleEveryTuesday || false,
  //   scheduleEveryWednesday: mainEvent?.scheduleEveryWednesday || false,
  //   scheduleEveryThursday: mainEvent?.scheduleEveryThursday || false,
  //   scheduleEveryFriday: mainEvent?.scheduleEveryFriday || false,
  //   scheduleEverySaturday: mainEvent?.scheduleEverySaturday || false,
  //   scheduleEverySunday: mainEvent?.scheduleEverySunday || false,
  // })

  // useEffect(() => {
  //   setLocalSchedule({
  //     scheduleEveryMonday: mainEvent?.scheduleEveryMonday || false,
  //     scheduleEveryTuesday: mainEvent?.scheduleEveryTuesday || false,
  //     scheduleEveryWednesday: mainEvent?.scheduleEveryWednesday || false,
  //     scheduleEveryThursday: mainEvent?.scheduleEveryThursday || false,
  //     scheduleEveryFriday: mainEvent?.scheduleEveryFriday || false,
  //     scheduleEverySaturday: mainEvent?.scheduleEverySaturday || false,
  //     scheduleEverySunday: mainEvent?.scheduleEverySunday || false,
  //   })
  // }, [mainEvent])

  // const dayChips = [
  //   { label: isMobile ? 'L' : 'Lun', field: 'scheduleEveryMonday', scheduled: localSchedule.scheduleEveryMonday },
  //   { label: isMobile ? 'M' : 'Mar', field: 'scheduleEveryTuesday', scheduled: localSchedule.scheduleEveryTuesday },
  //   { label: isMobile ? 'M' : 'Mer', field: 'scheduleEveryWednesday', scheduled: localSchedule.scheduleEveryWednesday },
  //   { label: isMobile ? 'J' : 'Jeu', field: 'scheduleEveryThursday', scheduled: localSchedule.scheduleEveryThursday },
  //   { label: isMobile ? 'V' : 'Ven', field: 'scheduleEveryFriday', scheduled: localSchedule.scheduleEveryFriday },
  //   { label: isMobile ? 'S' : 'Sam', field: 'scheduleEverySaturday', scheduled: localSchedule.scheduleEverySaturday },
  //   { label: isMobile ? 'D' : 'Dim', field: 'scheduleEverySunday', scheduled: localSchedule.scheduleEverySunday },
  // ]

  // const handlePresetChange = async (newPresetSlug: string) => {
  //   setSelectedPreset(newPresetSlug)

  //   const chosenPreset = presets.find((p) => p.slug === newPresetSlug)
  //   if (chosenPreset) {
  //     const updatedSchedule: Partial<CalendarEvent> = {
  //       title: chosenPreset.title, // Update the title
  //       scheduleEveryMonday: chosenPreset.scheduleEveryMonday,
  //       scheduleEveryTuesday: chosenPreset.scheduleEveryTuesday,
  //       scheduleEveryWednesday: chosenPreset.scheduleEveryWednesday,
  //       scheduleEveryThursday: chosenPreset.scheduleEveryThursday,
  //       scheduleEveryFriday: chosenPreset.scheduleEveryFriday,
  //       scheduleEverySaturday: chosenPreset.scheduleEverySaturday,
  //       scheduleEverySunday: chosenPreset.scheduleEverySunday,
  //     }
  //     const prevSchedule = { ...localSchedule }
  //     setLocalSchedule({
  //       scheduleEveryMonday: chosenPreset.scheduleEveryMonday,
  //       scheduleEveryTuesday: chosenPreset.scheduleEveryTuesday,
  //       scheduleEveryWednesday: chosenPreset.scheduleEveryWednesday,
  //       scheduleEveryThursday: chosenPreset.scheduleEveryThursday,
  //       scheduleEveryFriday: chosenPreset.scheduleEveryFriday,
  //       scheduleEverySaturday: chosenPreset.scheduleEverySaturday,
  //       scheduleEverySunday: chosenPreset.scheduleEverySunday,
  //     })

  //     try {
  //       await onUpdateMainEvent(updatedSchedule)
  //       // Optionally refetch calendar data if necessary
  //       // refetchCalendar && refetchCalendar()
  //     } catch (error) {
  //       // Revert to previous schedule on error
  //       setLocalSchedule(prevSchedule)
  //       // Optionally handle error state
  //     }
  //   }
  // }

  // const handleChipClick = async (field: string) => {
  //   const prevSchedule = { ...localSchedule }
  //   const updatedSchedule = {
  //     ...localSchedule,
  //     [field]: !localSchedule[field as keyof typeof localSchedule],
  //   }

  //   setLocalSchedule(updatedSchedule)

  //   try {
  //     await onUpdateMainEvent(updatedSchedule)
  //     // Optionally refetch calendar data if necessary
  //     // refetchCalendar && refetchCalendar()
  //   } catch (error) {
  //     // Revert changes on error
  //     setLocalSchedule(prevSchedule)
  //   }
  // }

  return (
    <Box>
      {/* <Box
        sx={{
          display: 'flex',
          gap: isMobile ? '10px' : '20px',
          marginBottom: '30px',
          marginTop: '16px',
          justifyContent: 'space-between',
          flexDirection: 'column',
        }}
      >
        <EmtTypography variant="body1" sx={{ fontWeight: 'bold' }}>
          Indiquez vos disponibilités générales
        </EmtTypography>
        <EmtSelect
          inputLabel={'Quand êtes vous disponible ?'}
          options={presets.map((item) => ({
            label: item.title || '',
            value: item.slug || '',
          }))}
          value={selectedPreset}
          sx={{ minWidth: isMobile ? '100%' : 'unset' }}
          onChange={(event) => {
            // @ts-ignore
            const newValue = event as string
            handlePresetChange(newValue)
          }}
        />
        <Box sx={{ display: 'flex', gap: '6px', flexShrink: '1', maxWidth: '100%' }}>
          {dayChips.map((chip, idx) => (
            <EmtChip
              key={idx}
              sx={{
                border: `1px solid ${chip.scheduled ? '#19BA92' : '#77757F'}`,
                width: '100%',
                height: '40px',
                borderRadius: '100vmax',
                cursor: 'pointer',
                backgroundColor: chip.scheduled ? '#E9FDF8' : '#ffffff00',
                '&:hover': {
                  backgroundColor: chip.scheduled ? '#E9FDF8' : '#f0f0f0',
                },
              }}
              onClick={() => handleChipClick(chip.field)}
              color={chip.scheduled ? 'successlight' : 'default'}
              label={chip.label}
            />
          ))}
        </Box>
      </Box> */}
      {/* <Box sx={{ marginBottom: '17px' }}>
        <EmtTypography variant="body1" sx={{ fontWeight: 'bold' }}>
          Avez-vous des empêchements ou des créneaux supplémentaires ?
        </EmtTypography>
        <EmtTypography variant="body1">
          Mettez à jour vos disponibilités directement dans votre calendrier.
        </EmtTypography>
      </Box> */}
      <Box sx={{ marginBottom: '17px' }}>
        <EmtTypography variant="body1" sx={{ fontWeight: 'bold' }}>
          Retirez les dates auxquelles vous êtes indisponible
        </EmtTypography>
        <EmtTypography variant="body1">
          Vos dates disponibles sont affichées en vert, vos indisponibilités en gris. Chaque mois est affiché
          séparément.
        </EmtTypography>
      </Box>
      <Box
        sx={{
          backgroundColor: '#fff',
          padding: '6px 16px 16px',
          borderRadius: '18px',
          border: '1px solid #E8E8EA',
        }}
      >
        <DisponibilityCalendar
          days={calendar.days}
          onAddRange={onAddRange}
          loading={loading}
          currentMonth={currentMonth}
          setCurrentMonth={setCurrentMonth}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            marginTop: '20px',
            maxHeight: '300px',
            overflowY: 'auto',
          }}
        >
          {filteredRanges.length > 0 && (
            <EmtTypography variant="body1" fontWeight="bold" color={'#4A4754'}>
              Vos indisponibilités de{' '}
              {(() => {
                const label = currentMonth.toLocaleString('fr-FR', { month: 'long', year: 'numeric' })
                return label.charAt(0).toUpperCase() + label.slice(1)
              })()}{' '}
              :
            </EmtTypography>
          )}
          {filteredRanges.map((range, index) => (
            <Box
              key={range.uuid || index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                border: '1px solid #E8E8EA',
                backgroundColor: '#fff',
                borderRadius: '16px',
                padding: '12px 15px 12px 20px',
                width: '100%',
              }}
            >
              <Box sx={{ display: 'flex', gap: '10px' }}>
                <Box
                  sx={{
                    position: 'relative',
                    width: 32,
                    height: 32,
                    overflow: 'hidden',
                    borderRadius: '12px',
                    border: `1px solid ${range.type === 'ALL_SERVICES_AVAILABILITY' ? '#18BA92' : '#858585'}`,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexShrink: '0',
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: `${range.type === 'ALL_SERVICES_AVAILABILITY' ? '#18BA92' : '#F9F9F9'}`,
                      pointerEvents: 'none',
                    }}
                  />
                  <EmtIcon
                    className={range.type === 'ALL_SERVICES_AVAILABILITY' ? 'emt-tick' : 'emt-x'}
                    sx={{
                      color: `${range.type === 'ALL_SERVICES_AVAILABILITY' ? '#E9FDF8' : '#858585'}`,
                      fontSize: '16px',
                      zIndex: 1,
                      position: 'absolute',
                    }}
                  />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <EmtTypography variant="body2" color={'#4A4754'}>
                    {range.start.toDateString() === range.end.toDateString() ? (
                      <>
                        Le <b>{formatDate(range.start)}</b>
                      </>
                    ) : (
                      <>
                        Du <b>{formatDate(range.start)}</b> au <b>{formatDate(range.end)}</b>
                      </>
                    )}
                  </EmtTypography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Box
                  sx={{
                    width: '32px',
                    height: '32px',
                    backgroundColor: '#F4D4FD80',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: range.uuid && loading.delete.has(range.uuid) ? 'not-allowed' : 'pointer',
                    opacity: range.uuid && loading.delete.has(range.uuid) ? 0.6 : 1,
                    pointerEvents: range.uuid && loading.delete.has(range.uuid) ? 'none' : 'auto',
                  }}
                  onClick={() => handleDeleteRange(index)}
                >
                  {range.uuid && loading.delete.has(range.uuid) ? (
                    <CircularProgress size={16} />
                  ) : (
                    <EmtIcon className="emt-bin-1" size="small" sx={{ fontSize: '16px', color: '#AE59C6' }} />
                  )}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default CalendarComponent
